import React, { forwardRef } from 'react';

export interface DateInputProps {
    value?: string;
    onClick?: () => void;
}

export const DateInput = forwardRef<HTMLDivElement, DateInputProps>(
    ({ value, onClick }, ref) => (
        <div ref={ref} className="btn ff-wires__date-input" onClick={onClick}>
            {value || 'Select a date'}
        </div>
    )
);
